var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCameraIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4457 13H2.54348C1.13835 13 0 11.8617 0 10.4565V2.54348C0 1.13835 1.13835 0 2.54348 0H11.4457C12.8508 0 13.9891 1.13835 13.9891 2.54348V10.4565C13.9891 11.8617 12.8508 13 11.4457 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9893 7.73979L18.2793 11.1921C19.1113 11.8625 20.348 11.2701 20.348 10.2019V2.79752C20.348 1.72926 19.1113 1.13692 18.2793 1.80726L13.9893 5.25961",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCameraIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CameraIcon.51c69ebf.svg";
export { ForwardRef as ReactComponent };